module.exports = __webpack_public_path__ + "static/media/dautry.89026a76.jpg";